// extracted by mini-css-extract-plugin
module.exports = {"w1ettitm":"w1ettitm"};